/**
 * Guest Token Management
 * Stores and retrieves guest tokens from localStorage
 */

const GUEST_TOKEN_KEY = 'logogen_guest_token';

export function getGuestToken() {
  return localStorage.getItem(GUEST_TOKEN_KEY);
}

export function setGuestToken(token) {
  localStorage.setItem(GUEST_TOKEN_KEY, token);
}

export function clearGuestToken() {
  localStorage.removeItem(GUEST_TOKEN_KEY);
}

export function hasGuestToken() {
  return !!getGuestToken();
}
